module.exports = __webpack_public_path__ + "media/images/icons/flags/TC-cef7042eb425872607202f7088aa6522.svg";